export enum BADGE_POSITION {
    badge = 'badge',
    rightCorner = 'rightCorner',
}
